/**
 * Deep-link del bot de Telegram para consumir una invitación.
 *
 * `/start invite_<token>` lo maneja el bot (`onboarding.service.ts` / `bot.service.ts`):
 * si el teléfono que comparte el usuario ya tiene cuenta, la VINCULA al telegramId;
 * si no, crea la cuenta con los roles/accesos de la invitación. Por eso el mismo
 * link sirve tanto para un usuario nuevo como para uno existente "Sin vincular".
 *
 * Devuelve null si el build no trae VITE_TELEGRAM_BOT_USERNAME.
 */
export function telegramInviteDeepLink(token: string): string | null {
  const bot = (import.meta.env.VITE_TELEGRAM_BOT_USERNAME as string | undefined)?.trim();
  if (!bot || !token) return null;
  return `https://t.me/${bot}?start=invite_${encodeURIComponent(token)}`;
}
